import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "distributor_details"
};
const _hoisted_2 = {
  class: "base_details_content"
};
const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "折扣设置", -1);

const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  key: 2
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  key: 2
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  key: 2
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  key: 2
};

const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "专享折扣", -1);

const _hoisted_18 = {
  class: "dialog-footer"
};
import { ref, reactive, computed } from "vue";
import api from "@api/equity";
import $ from "@util/base";
import useRoute from "@util/router";
import DataCollectTable from "@com/table/DataCollectTable.vue";
import { COLUMN_TYPE, OP_KEY, OPERATIONS, operationsHander } from "@com/table/tableOperations";
import { $box, $msg } from "@/common/ui/msg";
import BackTitleView from "@com/BackTitleView.vue";
import ProductTable from "@com/marketing/ProductTable.vue";
import DynamicParams from "@/components/DynamicParams.vue";
import MapSelectAddress from "@/components/MapSelectAddress.vue";
export default {
  __name: 'MemberGradePowerPlusDetails',

  setup(__props) {
    const total = ref(0);
    const route = useRoute();
    const urlQuery = route.query();
    const TYPE = {
      1003001: {
        title: '商品',
        val: 'goods'
      },
      1003002: {
        title: '旅行',
        val: 'travel'
      },
      1003003: {
        title: '酒店',
        val: 'hotel'
      }
    };
    const config = {
      operations: {
        label: "操作",
        width: 120,
        operations: getOperations
      },
      column: [{
        label: "产品类型",
        prop: "productCategory"
      }, {
        label: "产品编号",
        prop: "code",
        width: 100
      }, {
        label: "折扣",
        prop: "discount"
      }]
    };
    const tableData = ref([]);
    const baseFormRef = ref(null);
    const baseForm = ref({
      name: '年卡会员',
      money: 0,
      integral: 0,
      discountTravel: 0,
      travelNotIn: '',
      discountTravel1: 0,
      travel1NotIn: '',
      discountHotel: 0,
      hotelNotIn: '',
      discountProduct: 0,
      productNotIn: '',
      exclusiveDiscountsItemList: []
    });
    const baseFormRules = {
      name: [{
        required: true,
        message: '请输入权益名称',
        trigger: 'blur'
      }],
      money: [{
        required: true,
        message: '请输入消费金额',
        trigger: 'blur'
      }],
      integral: [{
        required: true,
        message: '请输入获得积分',
        trigger: 'blur'
      }]
    };
    const readOnly = ref(false);
    const title = ref('权益详情');
    const drawerTitle = ref('不参与折扣商品');
    const dialogVisible = ref(false);
    const type = ref(null);
    const drawer = ref(false);
    const typeKey = ref(null);
    const isExclusiveDiscount = ref(false);
    const memberGradePowerDetailAddTableRef = ref(null);
    const exclusiveDiscountsItemRef = ref(null);
    $.handleCRU(urlQuery.type, {
      show: () => {
        readOnly.value = true;
        title.value = "权益详情";
        getData();
      },
      add: () => {
        title.value = "权益新增";
        initData();
      },
      modify: () => {
        title.value = "权益修改";
        getData();
      }
    });

    function getOperations(data) {
      return [OPERATIONS.del];
    }

    const opHander = operationsHander();
    opHander.install(OP_KEY.delete, data => {
      $box.open("删除", "确认删除线路" + data.lineName, () => {
        api.del(data.id, () => {
          $msg.succ("删除成功");
          getData();
        });
      });
    });

    function getData() {
      api.plusGet(urlQuery.equityCode, res => {
        if (res.equityItem) {
          if (res.equityItem.exclusiveDiscountsItemList) {
            res.equityItem.exclusiveDiscountsItemList.forEach(item => {
              if (item.type) {
                item.productCategory = TYPE[item.type].title;
              }
            });
          }

          baseForm.value = res.equityItem;
          const v1 = {
            productCategory: '折扣（%）',
            value1: res.equityItem.discountProduct,
            value2: res.equityItem.discountTravel,
            value3: res.equityItem.discountHotel,
            value4: res.equityItem.discountTravel1
          };
          const v2 = {
            productCategory: '不参与折扣商品',
            value1: res.equityItem.productNotIn,
            value2: res.equityItem.travelNotIn,
            value3: res.equityItem.hotelNotIn,
            value4: res.equityItem.travel1NotIn
          };
          tableData.value.push(v1);
          tableData.value.push(v2);
        }
      });
    }

    function initData() {
      const v1 = {
        productCategory: '折扣（%）',
        value1: 0,
        value2: 0,
        value3: 0
      };
      const v2 = {
        productCategory: '不参与折扣商品',
        value1: '',
        value2: '',
        value3: ''
      };
      tableData.value.push(v1);
      tableData.value.push(v2);
    }

    function poolOperation(readOnly) {
      if (readOnly) {
        return {
          del: false,
          add: false
        };
      } else {
        return {
          del: true,
          add: true
        };
      }
    }

    function add() {
      drawerTitle.value = '专享折扣商品';
      isExclusiveDiscount.value = true;
      dialogVisible.value = true;
    }

    function del(index) {
      baseForm.value.exclusiveDiscountsItemList.splice(index, 1);
    }

    function submitType() {
      dialogVisible.value = false;
      typeKey.value = TYPE[type.value].val;
      drawer.value = true;
    }

    function openDrawer(item) {
      drawerTitle.value = '不参与折扣商品';
      isExclusiveDiscount.value = false;

      if (item.column.property === 'value1') {
        typeKey.value = 'goods';
      } else if (item.column.property === 'value2') {
        typeKey.value = 'travel1';
      } else if (item.column.property === 'value3') {
        typeKey.value = 'hotel';
      } else if (item.column.property === 'value4') {
        typeKey.value = 'travel2';
      }

      console.log(typeKey.value);
      drawer.value = true;
    }

    function closeDrawer() {
      drawer.value = false;
    }

    function saveProduct() {
      let data = memberGradePowerDetailAddTableRef.value.getSelectData();

      if ($.isEmpty(data)) {
        $msg.error("请勾选需要添加的产品");
      } else {
        if (isExclusiveDiscount.value) {
          const newAr = data.filter(f => {
            const index = baseForm.value.exclusiveDiscountsItemList.findIndex(i => i.code === f.code);
            return index === -1;
          }).map(item => {
            return {
              code: item.code,
              discount: 0,
              type: type.value,
              name: item.name,
              mainPic: item.mainPic,
              productCategory: TYPE[type.value].title
            };
          });
          baseForm.value.exclusiveDiscountsItemList = baseForm.value.exclusiveDiscountsItemList.concat(newAr);
        } else {
          const codes = data.map(item => item.code).join(',');

          if (typeKey.value === 'goods') {
            tableData.value[1].value1 = codes;
          } else if (typeKey.value === 'travel1') {
            tableData.value[1].value2 = codes;
          } else if (typeKey.value === 'hotel') {
            tableData.value[1].value3 = codes;
          } else if (typeKey.value === 'travel2') {
            tableData.value[1].value4 = codes;
          }
        }

        closeDrawer();
      }
    }

    function back() {
      route.go(-1);
    }

    function save() {
      baseFormRef.value.validate(valid => {
        if (valid) {
          if ($.isNotEmpty(tableData.value)) {
            baseForm.value.discountProduct = tableData.value[0].value1 || 0;
            baseForm.value.discountTravel = tableData.value[0].value2 || 0;
            baseForm.value.discountTravel1 = tableData.value[0].value4 || 0;
            baseForm.value.discountHotel = tableData.value[0].value3 || 0;
            baseForm.value.productNotIn = tableData.value[1].value1 || '';
            baseForm.value.travelNotIn = tableData.value[1].value2 || '';
            baseForm.value.travel1NotIn = tableData.value[1].value4 || '';
            baseForm.value.hotelNotIn = tableData.value[1].value3 || '';
            const data = { ...baseForm.value,
              exclusiveDiscountsItemList: baseForm.value.exclusiveDiscountsItemList.map(item => {
                return {
                  code: item.code,
                  discount: item.discount,
                  type: item.type,
                  name: item.name,
                  mainPic: item.mainPic
                };
              })
            };
            data.code = urlQuery.code;
            $.handleCRU(urlQuery.type, {
              add: () => {
                api.plusAdd(data, () => {
                  $msg.succ("添加成功");
                  back();
                });
              },
              modify: () => {
                data.equityCode = urlQuery.equityCode;
                api.plusAdd(data, () => {
                  $msg.succ("修改成功");
                  back();
                });
              }
            });
          } else {
            $msg.error("请完善产品折扣信息");
          }
        }
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_table = _resolveComponent("el-table");

      const _component_UploadSinglePicture = _resolveComponent("UploadSinglePicture");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_el_drawer = _resolveComponent("el-drawer");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: title.value
        }, null, 8, ["title"]), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_form, {
            ref_key: "baseFormRef",
            ref: baseFormRef,
            model: baseForm.value,
            rules: baseFormRules,
            "label-width": "100px",
            class: "base_details_form",
            disabled: readOnly.value
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "消费金额",
              prop: "money"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: baseForm.value.money,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => baseForm.value.money = $event),
                modelModifiers: {
                  number: true
                },
                min: 0,
                precision: 2,
                controls: false,
                "controls-position": "right"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "获得积分",
              prop: "integral"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: baseForm.value.integral,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => baseForm.value.integral = $event),
                modelModifiers: {
                  number: true
                },
                min: 0,
                precision: 2,
                controls: false,
                "controls-position": "right"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model", "disabled"]), _createVNode(_component_el_table, {
            data: tableData.value,
            style: {
              "width": "100%"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "产品类目",
              prop: "productCategory"
            }), _createVNode(_component_el_table_column, {
              label: "商品",
              prop: "value1"
            }, {
              default: _withCtx(scope => [scope.$index === 0 ? (_openBlock(), _createElementBlock("p", _hoisted_5, [_createVNode(_component_el_input, {
                disabled: readOnly.value,
                style: {
                  "width": "80px"
                },
                modelValue: scope.row.value1,
                "onUpdate:modelValue": $event => scope.row.value1 = $event,
                type: "number"
              }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])])) : _createCommentVNode("", true), scope.$index === 1 && !readOnly.value ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                onClick: $event => openDrawer(scope)
              }, [_createElementVNode("span", null, _toDisplayString(scope.row.value1 || '选择'), 1)], 8, _hoisted_6)) : scope.$index === 1 && readOnly.value ? (_openBlock(), _createElementBlock("p", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(scope.row.value1 || ''), 1)])) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "境内旅游",
              prop: "value2"
            }, {
              default: _withCtx(scope => [scope.$index === 0 ? (_openBlock(), _createElementBlock("p", _hoisted_8, [_createVNode(_component_el_input, {
                disabled: readOnly.value,
                style: {
                  "width": "80px"
                },
                modelValue: scope.row.value2,
                "onUpdate:modelValue": $event => scope.row.value2 = $event,
                type: "number"
              }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])])) : _createCommentVNode("", true), scope.$index === 1 && !readOnly.value ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                onClick: $event => openDrawer(scope)
              }, [_createElementVNode("span", null, _toDisplayString(scope.row.value2 || '选择'), 1)], 8, _hoisted_9)) : scope.$index === 1 && readOnly.value ? (_openBlock(), _createElementBlock("p", _hoisted_10, [_createElementVNode("span", null, _toDisplayString(scope.row.value2 || ''), 1)])) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "境外旅游",
              prop: "value4"
            }, {
              default: _withCtx(scope => [scope.$index === 0 ? (_openBlock(), _createElementBlock("p", _hoisted_11, [_createVNode(_component_el_input, {
                disabled: readOnly.value,
                style: {
                  "width": "80px"
                },
                modelValue: scope.row.value4,
                "onUpdate:modelValue": $event => scope.row.value4 = $event,
                type: "number"
              }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])])) : _createCommentVNode("", true), scope.$index === 1 && !readOnly.value ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                onClick: $event => openDrawer(scope)
              }, [_createElementVNode("span", null, _toDisplayString(scope.row.value4 || '选择'), 1)], 8, _hoisted_12)) : scope.$index === 1 && readOnly.value ? (_openBlock(), _createElementBlock("p", _hoisted_13, [_createElementVNode("span", null, _toDisplayString(scope.row.value4 || ''), 1)])) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "酒店",
              prop: "value3"
            }, {
              default: _withCtx(scope => [scope.$index === 0 ? (_openBlock(), _createElementBlock("p", _hoisted_14, [_createVNode(_component_el_input, {
                disabled: readOnly.value,
                style: {
                  "width": "80px"
                },
                modelValue: scope.row.value3,
                "onUpdate:modelValue": $event => scope.row.value3 = $event,
                type: "number"
              }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])])) : _createCommentVNode("", true), scope.$index === 1 && !readOnly.value ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                onClick: $event => openDrawer(scope)
              }, [_createElementVNode("span", null, _toDisplayString(scope.row.value3 || '选择'), 1)], 8, _hoisted_15)) : scope.$index === 1 && readOnly.value ? (_openBlock(), _createElementBlock("p", _hoisted_16, [_createElementVNode("span", null, _toDisplayString(scope.row.value3 || ''), 1)])) : _createCommentVNode("", true)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"]), _hoisted_17, _createVNode(DynamicParams, {
            ref_key: "exclusiveDiscountsItemRef",
            ref: exclusiveDiscountsItemRef,
            data: baseForm.value.exclusiveDiscountsItemList,
            typeProp: "detailType",
            showDefault: readOnly.value,
            customAdd: true,
            onAdd: add,
            operation: poolOperation(readOnly.value),
            customDel: true,
            onDelete: del
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "产品类型",
              prop: "productCategory"
            }), _createVNode(_component_el_table_column, {
              label: "产品图片",
              align: "center",
              width: "120"
            }, {
              default: _withCtx(scope => [_createVNode(_component_UploadSinglePicture, {
                modelValue: scope.row.mainPic,
                "onUpdate:modelValue": $event => scope.row.mainPic = $event,
                width: 100,
                disabled: true
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "产品编号",
              prop: "code"
            }), _createVNode(_component_el_table_column, {
              label: "产品名称",
              prop: "name"
            }), _createVNode(_component_el_table_column, {
              label: "折扣",
              prop: "discount"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input, {
                modelValue: scope.row.discount,
                "onUpdate:modelValue": $event => scope.row.discount = $event,
                type: "number",
                disabled: readOnly.value
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data", "showDefault", "operation"])])]), _createVNode(_component_el_dialog, {
            modelValue: dialogVisible.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => dialogVisible.value = $event),
            title: "选择",
            width: "35%",
            top: "35vh",
            class: "base_dialog"
          }, {
            footer: _withCtx(() => [_createElementVNode("span", _hoisted_18, [_createVNode(_component_el_button, {
              type: "primary",
              onClick: submitType
            }, {
              default: _withCtx(() => [_createTextVNode("保存")]),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = $event => dialogVisible.value = false)
            }, {
              default: _withCtx(() => [_createTextVNode("取消")]),
              _: 1
            })])]),
            default: _withCtx(() => [_createVNode(_component_el_form, null, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "选择类型",
                prop: "type"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                  modelValue: type.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => type.value = $event)
                }, {
                  default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(TYPE, (value, key, index) => {
                    return _createVNode(_component_el_radio, {
                      label: key,
                      key: index
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(value.title), 1)]),
                      _: 2
                    }, 1032, ["label"]);
                  }), 64))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_drawer, {
            modelValue: drawer.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => drawer.value = $event),
            title: drawerTitle.value,
            direction: "rtl",
            "close-on-click-modal": false,
            size: "60%",
            "custom-class": "base_drawer"
          }, {
            footer: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_button, {
              onClick: closeDrawer
            }, {
              default: _withCtx(() => [_createTextVNode("取消")]),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: saveProduct,
              type: "primary"
            }, {
              default: _withCtx(() => [_createTextVNode("保存")]),
              _: 1
            })])]),
            default: _withCtx(() => [_createVNode(ProductTable, {
              type: "add",
              ref_key: "memberGradePowerDetailAddTableRef",
              ref: memberGradePowerDetailAddTableRef,
              typeKey: typeKey.value
            }, null, 8, ["typeKey"])]),
            _: 1
          }, 8, ["modelValue", "title"])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), !readOnly.value ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: save,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存")]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }

};